import { enforce, omitWhen, test } from 'vest';

import {
  isEndpointUrl,
  withDefaults,
} from 'admin-panel/utils/integrations/config';

import type { IntegrationConfig } from 'admin-panel/models/integrations/configuration';
import type {
  IntegrationFormValues,
  ServiceFormDefinition,
} from 'admin-panel/utils/integrations/types';

export interface InforService {
  apiBaseUrl: string;
  user: string;
  password: string;
  property: string;
}

const SERVICE = 'currentConfig.service';

const defaultConfig = (): IntegrationConfig => ({
  service: {
    apiBaseUrl: '',
    user: '',
    password: '',
    property: '',
  },
  features: {},
  cron: [],
  webhooks: [{ name: 'reservations', enabled: true }],
});

export const infor: ServiceFormDefinition = {
  toFormConfig: (config) => withDefaults(defaultConfig(), config),

  validate(values: IntegrationFormValues, t) {
    const service = values.currentConfig.service as unknown as InforService;

    test(`${SERVICE}.apiBaseUrl`, t('validations.required'), () => {
      enforce(service.apiBaseUrl).isNotBlank();
    });

    omitWhen(!service.apiBaseUrl, () => {
      test(`${SERVICE}.apiBaseUrl`, t('validations.url'), () => {
        enforce(isEndpointUrl(service.apiBaseUrl)).isTruthy();
      });
    });

    for (const field of ['user', 'password'] as const) {
      test(`${SERVICE}.${field}`, t('validations.required'), () => {
        enforce(service[field]).isNotBlank();
      });
    }
  },
};
